import { useContext, useEffect, useMemo, useRef } from "react";
import { CardOne } from "../cards/cardOne";
import { GoBackButton } from "../buttons/goBack";
import { themeContext } from "../../context/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";
import { navigationGamepadLoop, playSound } from "../../utilities/utilities";
import styles from "./MobileWarning.module.css";

export const MobileWarning = ({ onBack, game }) => {
  const { theme } = useContext(themeContext);

  const sectionRef = useRef(null);
  const gamepadLoopState = useMemo(() => ({ run: true }), []);

  useEffect(() => {
    sectionRef.current?.focus();
  }, []);

  useEffect(() => {
    navigationGamepadLoop(
      game,
      (event) => {
        if (event.key === "Back" || event.key === "Escape") {
          gamepadLoopState.run = false;
          playSound(game, "click");
          onBack();
        }
      },
      gamepadLoopState
    );
    return () => {
      gamepadLoopState.run = false;
    };
  }, []);

  return (
    <CardOne
      customTag="section"
      attributes={{
        ref: sectionRef,
        className: styles.section,
        tabIndex: -1,
        onKeyDown: (event) => {
          if (event.key === "Escape" || event.key === "Backspace") {
            event.preventDefault();
            onBack();
          }
        },
      }}
    >
      <GoBackButton onClickHandler={onBack} game={game} />
      <div className={styles.content}>
        <FontAwesomeIcon
          icon={faMobileScreenButton}
          className={`${styles.icon} ${styles["icon-" + theme]}`}
        />
        <h2 className={styles.title}>Best on Larger Screens</h2>
        <p className={styles.message}>
          This mode is designed for bigger screens like laptop, tablet, monitor. Please switch to a bigger device for the best experience.
        </p>
      </div>
    </CardOne>
  );
};
